<template lang="pug">
    div.adminHome
        .slider.projects(:class='{updating:updatingProjectInd!==null}')
            .swiper-container
                .swiper-wrapper
                    .swiper-slide(v-for='(prj, ind) in projects' :key='ind')
                        .content
                            .photoContainer
                                .photo(:style="{backgroundImage:updatingData.img&&updatingProjectInd===ind?'url('+tempFile+')':'url('+$rootPath+'/backend/img/homeSlides/'+prj.img+')'}")
                            .text(v-if='updatingProjectInd===null')
                                h3(v-html='prj.title')
                                p(v-html='prj.subtitle')
                            .text(v-else-if='updatingProjectInd!==null')
                                h3(v-html='updatingData.title')
                                p(v-html='updatingData.subtitle')
                        .operations
                            .updateSlide(@click='updateSlide(ind)' title='Изменить')
                            .createSlide(@click='createSlide()' title='Создать')
                            .deleteSlide(@click='deleteSlide(prj.id)' title='Удалить')

        .updatingForm(v-if='updatingProjectInd!==null')
            .container
                .row
                    form.col.s12(@submit.prevent='')
                        .file-field.input-field.col.s6
                            .btn.orange.darken-2
                                span Изображение
                                input(type='file' @change='updatingData.img = $event.target.files[0]; showFile()')
                                small.helper-text.invalid(v-if='formError') {{formError}}
                            .file-path-wrapper
                                input.file-path.validate(type='text')
                        .row.col.s6
                            .input-field
                                textarea#title.materialize-textarea(data-length='120' v-model='updatingData.title')
                                label(for='title') Заголовок
                            .input-field
                                textarea#subtitle.materialize-textarea(data-length='120' v-model='updatingData.subtitle')
                                label(for='subtitle') Подзаголовок
                        .row.col.right
                            button.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="action==='update'?cancleUpdate():action==='create'?cancleCreate():''") Отмена
                                i.material-icons.right cancel
                            button.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="action==='update'?saveUpdates():action==='create'?saveCreate():''") Сохранить
                                i.material-icons.right save
        section.contacts.admin
            .yellowP
            .blackFigure Контакты
            .container
                .content
                    .map
                    .address
                        h3 Вы можете к нам прийти, позвонить нам или написать, мы&nbsp;будем рады:
                            .updateContacts(@click='updatingContacts=true' title='Изменить')
                        div(v-html="contacts")
        .updatingContactsForm(v-if='updatingContacts')
            .row
                form(@submit.prevent='')
                    .file-field.input-field.col.s12.formFile
                        .input-field
                            textarea#title6.materialize-textarea(data-length='120' v-model="contacts")
                            label(for='title6') Контакты
                    .row
                        button.col.s5.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="updatingContacts=false") Отмена
                            i.material-icons.right cancel
                        button.col.s5.offset-s2.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="updateContacts()") Сохранить
                            i.material-icons.right save


</template>

<script>
    import materialize from 'materialize-css/dist/js/materialize.min'

    export default {
        name: "HomeUpdate",
        data: () => ({
            slider: null,
            projects: [],
            updatingData: {
                title: '',
                subtitle: '',
                img: '',
            },
            formError: '',
            tempFile: null, //Временный файл для показа изображения
            updatingProjectInd: null,
            action: '',

            contacts:'', // контакты
            updatingContacts: false, // для показа попапа обновления
        }),
        watch:{
            updatingContacts(value){
                  if (value){
                      setTimeout(() => {
                          M.updateTextFields();
                      })
                  }
            }
        },
        methods: {

            async fetchSlides() {
                let data = this.compileFormData({action: 'fetchHomeSlides',})
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error) {
                    this.projects = responseData.slides;
                    setTimeout(()=>{
                        this.slider.update()
                    });
                } else {
                    console.log(responseData);
                }
            },

            createSlide() {
                this.action = 'create';
                this.projects.push({title: '', subtitle: '', img: ''});
                setTimeout(() => {
                    this.slider.update();
                    this.slider.slideTo(this.projects.length, 1000);
                    this.updatingProjectInd = this.projects.length - 1;
                });
            },
            async saveCreate() {
                let data = this.compileFormData({
                    action: 'createHomeSlide',
                    title: this.updatingData.title,
                    subtitle: this.updatingData.subtitle,
                    img: this.updatingData.img
                })
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error && responseData.success) {
                    this.fetchSlides();
                    this.clearForm();
                } else {
                    this.formError = responseData.message;
                }
            },
            cancleCreate() {
                this.action = '';
                this.projects.pop();
                setTimeout(() => {
                    this.slider.update();
                    this.slider.slideTo(this.projects.length, 1000);
                });
                this.clearForm();
            },

            updateSlide(ind) {
                this.action = 'update';
                let currentProject = this.projects[ind];
                this.updatingData.title = currentProject.title;
                this.updatingData.subtitle = currentProject.subtitle;
                this.updatingProjectInd = ind;
                setTimeout(() => {
                    M.updateTextFields();
                })
            },
            async saveUpdates() {
                let data = this.compileFormData({
                    action: 'updateHomeSlide',
                    id: this.projects[this.updatingProjectInd].id,
                    title: this.updatingData.title,
                    subtitle: this.updatingData.subtitle,
                    img: this.updatingData.img
                })
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error && responseData.success) {
                    this.fetchSlides();
                    this.clearForm();
                } else {
                    this.formError = responseData.message;
                }
            },
            cancleUpdate() {
                this.action = '';
                this.clearForm();
            },


            deleteSlide(id) {
                this.saveDelete(id)
            },
            async saveDelete(id) {
                let data = this.compileFormData({
                    action: 'deleteHomeSlide',
                    id: id
                })
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error && responseData.success) {
                    this.fetchSlides();
                    this.clearForm();
                } else {
                    this.formError = responseData.message;
                }
            },

            showFile() {
                let f = this.updatingData.img;
                if (!f.type.match('image.*')) return;
                var fr = new FileReader();
                fr.onload = (() => (e) => {
                    this.tempFile = e.target.result;
                })(f);
                fr.readAsDataURL(f);
            },
            compileFormData(data) {
                let formData = new FormData();
                for (let pr in data) {
                    formData.append(pr, data[pr]);
                }
                return formData;
            },
            clearForm() {
                this.updatingData.title = '';
                this.updatingData.subtitle = '';
                this.updatingData.img = '';
                this.updatingProjectInd = null;
                this.tempFile = null;
                this.formError = '';
            },

            async fetchContacts(){
                let data = this.compileFormData({action: 'fetchContacts',})
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error) {
                    this.contacts = responseData.contacts;
                } else {
                    console.log(responseData);
                }
            },
            async updateContacts(){
                let data = this.compileFormData({
                    action: 'updateContacts',
                    content: this.contacts,
                })
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error) {
                    this.updatingContacts = false;
                }
            },
        },
        mounted() {
            this.fetchSlides();
            this.fetchContacts();
            M.updateTextFields();
            this.slider = new Swiper('.projects.slider .swiper-container', {
                slidesPerView: 2.2,
                spaceBetween: 100,
                slideActiveClass: 'active',
                centeredSlides: true,
                grabCursor: true,
            });
        }
    }
</script>
<style>
    .adminHome .content .address p{
        margin-bottom: 2rem;
        font: 400 16px/24px Geometria;
    }
</style>
<style scoped lang="scss">
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_functions.scss";

        .projects.slider {
            position: relative;
            width: 100%;
            padding-top: 5vh;

            &.updating {
                pointer-events: none;
            }


            .poolCircle {
                position: absolute;
                top: 29%;
                left: calc(30rem + 46.7%);
                height: 8rem;
                width: 8rem;
                background: url(../../assets/img/poolCircle.png) no-repeat center center/100% 100%;
            }

            .swiper-container {
                overflow: visible;

                .swiper-wrapper {
                    .swiper-slide {
                        position: relative;
                        transition: .5s;

                        &:not(.active) {
                            transform-origin: center;
                            transform: scale(0.6);

                            .photoContainer {
                                transform: scale(1) !important;
                            }

                            .text {
                                opacity: 0 !important;
                            }
                        }

                        &.active {
                            .operations {
                                opacity: 1;

                                div {
                                    cursor: pointer;
                                }
                            }
                        }

                        .operations {
                            position: absolute;
                            right: 0;
                            top: 5%;
                            display: flex;
                            flex-direction: column;
                            opacity: 0;

                            div {
                                height: 3rem;
                                width: 3rem;
                                margin-bottom: 1rem;
                                background: no-repeat center center/contain;
                            }

                            .updateSlide {
                                background-image: url(../../assets/img/admin/update-icon.png);
                            }

                            .createSlide {
                                background-image: url(../../assets/img/admin/create-icon.png);
                            }

                            .deleteSlide {
                                background-image: url(../../assets/img/admin/delete-icon.png);
                            }
                        }


                        .content {
                            position: relative;
                            height: 42.6rem;
                            width: 53rem;

                            .photoContainer {
                                position: relative;
                                height: 100%;
                                width: 43.5rem;
                                background: #ffc819;
                                clip-path: polygon(59% 0, 100% 0, 100% 49%, 77% 100%, 0 100%, 0% 24%);
                                transition: .3s linear;

                                .photo {
                                    position: absolute;
                                    right: 0;
                                    bottom: 0;
                                    left: 13%;
                                    top: 12.5%;
                                    background: no-repeat center center /cover;
                                    clip-path: polygon(59% 0, 100% 0, 100% 49%, 77% 100%, 0 100%, 0% 24%);
                                    transition: .3s linear;
                                }
                            }

                            .text {
                                position: absolute;
                                top: 65.6%;
                                left: 78.5%;
                                width: 39%;
                                transition: opacity .5s;

                                h3 {
                                    font: 700 to_rem(20px)/to_rem(24px) Geometria;
                                    margin-bottom: 2rem;
                                    transition: .3s linear;
                                }

                                p {
                                    font: 400 to_rem(16px)/to_rem(24px) Geometria;
                                    transition: .3s linear;
                                }
                            }
                        }
                    }
                }
            }
        }

        section.contacts {
            position: relative;
            display: flex;
            align-items: center;
            .container{
                max-width: 100%;
                padding: 0;
            }
            .yellowP {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                pointer-events: none;
                transform-origin: center;
                background: url(../../assets/img/contacts_bg-yellow.svg) no-repeat 57.2% center/auto 81%;
            }
            .content {
                display: flex;
                .map {
                    height: 100vh;
                    flex-basis: 54%;
                    .ymap-container{
                        height: 100%;
                    }
                }
                .address {
                    flex-basis: 46%;
                    padding: 15.3% 0 16.2% 2.5%;
                    max-width: 27rem;
                    h3 {
                        position: relative;
                        margin-bottom: 2.2rem;
                        font: 700 to_rem(20px)/to_rem(24px) Geometria;
                        .updateContacts{
                            position: absolute;
                            top: 0;
                            left: 95%;
                            height: 3rem;
                            width: 3rem;
                            margin-bottom: 1rem;
                            cursor: pointer;
                            display: none;
                            background: url(../../assets/img/admin/update-icon.png) no-repeat center center/contain;
                        }
                        &:hover .updateContacts{
                            display: block;
                        }
                    }
                }
            }
        }

        .updatingForm {
            form {
                margin-top: 5vh;
                width: 80% !important;
                margin-left: 10% !important;

                small {
                    position: absolute !important;
                    color: red !important;
                    margin-top: 1rem;
                    font-size: 1rem !important;
                    font-weight: 400;
                    cursor: url(./../../assets/img/cursor.png) 8 8, auto;
                }
                .input-field {
                    padding: 0;
                    textarea:focus + label {
                        color: $color !important;
                    }
                    textarea:focus {
                        border-bottom: 1px solid $color !important;
                        box-shadow: 0 1px 0 0 $color !important;
                    }
                }
                button[type="submit"] {
                    margin-left: 20px;
                }
            }
            @import "https://fonts.googleapis.com/icon?family=Material+Icons";
            @import "~materialize-css/sass/materialize";
        }
        .updatingContactsForm{
            position: fixed;
            top: 30%;
            left: 50%;
            transform: translateX(-50%);
            z-index: 200;
            width: 32rem;
            background: rgba(255, 255, 255, 0.8);
            form {
                margin: 1rem 1rem 0;
                .formFile {
                    margin-bottom: 3rem;
                    padding: 0 !important;
                }
                small {
                    position: absolute !important;
                    color: red !important;
                    font-size: 1rem !important;
                    font-weight: 400;
                    cursor: url(./../../assets/img/cursor.png) 8 8, auto;
                }
                .row {
                    margin-bottom: 0 !important;
                }
                .input-field {
                    padding: 0;
                    textarea {
                        resize: vertical;
                    }
                    textarea:focus + label {
                        color: $color !important;
                    }
                    textarea:focus {
                        border-bottom: 1px solid $color !important;
                        box-shadow: 0 1px 0 0 $color !important;
                    }
                }
            }
            @import "https://fonts.googleapis.com/icon?family=Material+Icons";
            @import "~materialize-css/sass/materialize";
        }

</style>
